import { numberLocaleFor } from "../i18n/locale";
import type { Locale } from "../i18n/locale";
import { uiFormat } from "../i18n/ui";

type Props = {
  locale: Locale;
  totalUsd: number;
  capUsd: number;
};

export function BudgetAlertBanner({ locale, totalUsd, capUsd }: Props) {
  const nf = numberLocaleFor(locale);
  const money = (n: number) =>
    n.toLocaleString(nf, {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 0,
    });

  return (
    <div className="banner" role="status">
      {uiFormat(locale, "budget.over", {
        total: money(totalUsd),
        cap: money(capUsd),
      })}
      <style>{`
        .banner {
          padding: 0.75rem 1rem;
          border-radius: 8px;
          border: 1px solid #8b4513;
          background: #2a1f18;
          color: #f0d4a8;
          font-size: 0.9rem;
        }
      `}</style>
    </div>
  );
}
